var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShrink = function SvgShrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    className: "icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M841.789 410.527H638.842a25.37 25.37 0 0 1-25.369-25.369V182.211a25.368 25.368 0 0 1 50.737 0v141.706L976.06 12.061a25.368 25.368 0 1 1 35.88 35.88L700.083 359.79h141.706a25.368 25.368 0 0 1 0 50.737M47.94 1011.939l311.85-311.856v141.706a25.368 25.368 0 0 0 50.737 0V638.842a25.37 25.37 0 0 0-25.369-25.369H182.211a25.368 25.368 0 0 0 0 50.737h141.706L12.061 976.06a25.368 25.368 0 0 0 35.88 35.88z"
  })));
};
export { SvgShrink as ReactComponent };
export default "/_next/static/images/shrink.svg";